import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './OurResultsData.scss';// to import local scss fle


const OurResultsData = () => (
  <div className={cn('row', styles.container)}>
    <div className={('col s12', styles.textContainer)}>
      <span className={styles.header}>OUR RESULTS</span>
      <span className={styles.desc}>
          Our goal is to make college sports recruiting more accessible
          through technology. To do so, we made it simple, but faster and
          more personal with greater exposure. MyRecruitBoard represents a
          new season in the relationship coaches and student athletes have with
          technology. It’s the most personalized college recruiting service ever
          developed, because it’s the first one designed to be truly interactive.
          You will receive up to the minute notifications for all your favorite
          users and can send messages more easily and intuitively.
          Connections are in your hands, not controlled by a third party evaluator.
          The people who know you best: coaches, counselors, and teachers, evaluate
          your talent so that college coaches can determine if you are the best fit
          for their program. With MyRecruitBoard every interaction is NOT about feeding
          you a sales pitch but IS about making a genuine connection...
      </span>
    </div>
  </div>
);

export default OurResultsData;



// WEBPACK FOOTER //
// ./src/components/OurResultsData/OurResultsData.js